import React from "react";
import instructionImage from "../../assets/images/DeathModuleNew/personalInstruction.png";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../redux/slices/loginSlice";
import protectedImg from "../../assets/images/DeathModuleNew/protectedWhite.svg";
import bulb from "../../assets/images/DeathModuleNew/bulb.png";

export const PersonalInstructionDashboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  {
    /*<div
      className="personalInstuction"
      style={{
        height: "50%",
        marginBottom: "1rem",
        cursor: "pointer",
        pointerEvents: props.role === "trustee" ? "none" : "",
        opacity: props.role === "trustee" ? "0.7" : "1",
      }}
      onClick={() => {
        dispatch(setActiveStep(3));
        history.push("/protector/death");
      }}
    >
      <div className="personalTitle personalPadding">Personal Instruction</div>
      {props.role !== "trustee" ? (
        <div
          className="personaldesc"
          style={{ paddingTop: "1rem", paddingInline: "1rem" }}
        >
          A personal user manual is a wonderful way to accelerate
          relationship-building with your team.
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "700",
            fontFamily: "Poppins",
            fontSize: "14px",
            flexDirection: "column",
            paddingInline: "1rem",
            textAlign:"center"
          }}
        >
          This Information will be available you soon!
          <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop: "8px" }}
            alt="protectedImg"
          ></img>
        </div>
      )}
        </div> */
  }
  return (
    <div
      className="personal-instruction-container"
      style={{
        cursor: "pointer",
        pointerEvents: props.role === "trustee" ? "none" : "",
        opacity: props.role === "trustee" ? "0.7" : "1",
      }}
      onClick={() => {
        dispatch(setActiveStep(3));
        history.push("/protector/death");
      }}
    >
      <div className="bulb-container">
        <img src={bulb} alt="bulb" />
      </div>
      <div className="text-position">
        <div className="personalTitle ">Personal Instruction</div>
        {props.role !== "trustee" ? (
          <div
            className="personaldesc"
            style={{ paddingTop: "1rem", paddingInline: "1rem" }}
          >
          Personal Instructions can be notes that might not be in a Will or Trust and can be highly personal, secretive, or simple instructions. Add them here. 
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection: "column",
              paddingInline: "1rem",
              textAlign: "center",
            }}
          >
            This Information will be available you soon!
            <img
              src={protectedImg}
              style={{ width: "50px", height: "50px", marginTop: "8px" }}
              alt="protectedImg"
            ></img>
          </div>
        )}
      </div>
    </div>
  );
};
